module.exports = __webpack_public_path__ + "img/i2.c82c6878.svg";